import * as Yup from "yup";
import { useEffect, useState } from "react";
import { useCustomForm } from "../../FormLogs/Hooks/useCustomForm";

export const useBookingFormValidation = (bookingConfig, category, amenity, serverErrors, onSubmit) => {
    const [errors, setErrors] = useState({});

    const { schema: customFormSchema } = useCustomForm(bookingConfig?.form ?? null);

    // When server errors change, merge with client errors to provide a single source of error truth
    useEffect(() => {
        setErrors({
            ...errors, ...serverErrors
        })
    }, [serverErrors])

    const getValidationRules = () => {
        return Yup.object({
            amenity_id: Yup.string()
                .required('Invalid amenity. Please go back and choose amenity again'),

            user_id: Yup.string()
                .required('Please select a user')
                .nullable(),

            unit_id: Yup.string().nullable(),

            start: Yup.string()
                .required('Please select a valid time')
                .typeError('Please select a valid time'),

            notes: Yup.string().max(255),

            terms_accepted: Yup.bool().test(
                'any-terms-accepted',
                'Terms & Conditions need to be accepted',
                (value, context) => {
                    return ((value === true) || !category.terms_required);
                }
            ),

            form: customFormSchema,

            visitors_notes: Yup.string().nullable().when('visitors_added', {
                is: true,
                then: Yup.string().max(255)
            }),

            visitors: Yup.array().nullable().when('visitors_added', {
                is: true,
                then: Yup.array().of(
                    Yup.object().shape({
                        name: Yup.string().required('Please enter a visitor name'),
                        email: Yup.string(),
                        company: Yup.string(),
                    })
                )
            })
        });
    }

    const submitValidatedForm = async (values) => {
        const validator = getValidationRules(bookingConfig);

        const isFormValid = await validator.isValid(values, {abortEarly: false})

        if (!isFormValid) {
            await validate(values);
        } else {
            setErrors({})
            onSubmit();
        }
    }

    const validate = async (values) => {
        const validator = getValidationRules(bookingConfig);

        let newErrors = {};

        await validator
            .validate(values, { abortEarly: false })
            .catch((err) => {
                const theseErrors = err.inner.reduce((acc, error) => {
                    return {
                        ...acc,
                        [error.path]: error.message
                    }
                }, {})
                newErrors = {...theseErrors};
            })

        setErrors(newErrors);
    }

    return {submitValidatedForm, validate, errors};
}
